// extracted by mini-css-extract-plugin
export default {"root":"SmsNumTimer_root__BJAMX","timer":"SmsNumTimer_timer__0eLYq","reload-timer":"SmsNumTimer_reload-timer__JAq5f"};